import React, { Fragment } from 'react';
import { isMobile as isDeviceMobile} from 'react-device-detect';
import { DEVICE_PLATFORMS } from 'constants/common';

/**
 * @desc Check if device is `mobile` and platform is `any-browser`.
 * @example
 * import { isMobile } from 'core/modules/device-detect';
 */
export const isMobile = () => {

	// when platform is other than default (desktop)
	return DEVICE_PLATFORMS.DEFAULT !== PLATFORM_NAME && isDeviceMobile;
};

/**
 * @desc Render children if device is `mobile` and platform is `any-browser`.
 * @example
 * import { ForMobile } from 'core/modules/device-detect';
 */
export const ForMobile = ( props ) => {
	if( isMobile() ) {
		return (
			<Fragment>
				{ props.children }
			</Fragment>
		);
	} else {
			return null;
		}
};
